import React from 'react'
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'

import { CustomTooltip } from '@application/Interfaces/Features/Graph/CustomTooltip'
import { useOrganization } from '@src/Application/Interfaces/Hooks/useOrganization/useOrganization'
import { GraphPieType, ThemeModeType } from '@src/Application/Types/ComponentTypes'

import { CustomLabel } from './CustomLabel'

const Layout: Record<ThemeModeType, Record<string, string | string[]>> = {
    Light: {
        strokeColor: 'white',
        colorPalette: ['a600', 'b600', 'c600', 'd600', 'p600', 'a500', 'b500', 'c500', 'd500', 'p500'],
    },
    Dark: {
        strokeColor: 'p600',
        colorPalette: ['a600', 'b600', 'c600', 'd600', 'p500', 'a500', 'b500', 'c500', 'd500', 'p300'],
    },
}

export const PieGraph = (props: GraphPieType): JSX.Element => {
    const { graphData, mode } = props

    const { theme } = useOrganization()

    const colorCodes = Layout[mode].colorPalette

    const strokeColorCode = Layout[mode].strokeColor
    const strokeColor = theme.color[strokeColorCode as string]

    return (
        <ResponsiveContainer width="100%" height={400}>
            <PieChart width={300} height={300}>
                <Pie
                    data={graphData}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    label={CustomLabel}
                    dataKey="value"
                    stroke={strokeColor}
                >
                    {graphData.map((entry, index) => {
                        const colorCode = colorCodes[index % colorCodes.length]
                        const color = theme.color[colorCode]
                        return <Cell key={`cell-${index}`} fill={color} name={entry.label} />
                    })}
                </Pie>
                <Legend />
                <Tooltip
                    content={<CustomTooltip />}
                    wrapperStyle={{ outline: 'none' }}
                    cursor={{ fill: 'transparent' }}
                />
            </PieChart>
        </ResponsiveContainer>
    )
}
